import type { ReactElement, ReactNode } from 'react';
import { Typography } from 'antd';
import { useTranslation } from '@govard/i18n-core/react';

export function EntityFieldList({
  fields,
}: {
  fields: { key: string; label: string; value?: ReactNode; copy?: string | undefined }[];
}): ReactElement {
  const { t } = useTranslation();
  return (
    <dl className="entity-field-list">
      {fields.map((field) => (
        <div key={field.key} className="entity-field-row">
          <dt>{field.label}</dt>
          <dd>
            {field.value === null || field.value === undefined || field.value === '' ? (
              <span className="entity-meta">—</span>
            ) : field.copy ? (
              <Typography.Text
                className="entity-copyable"
                copyable={{
                  text: field.copy,
                  tooltips: [t('crm.entity_detail.copy'), t('crm.entity_detail.copied')],
                }}
              >
                {field.value}
              </Typography.Text>
            ) : (
              field.value
            )}
          </dd>
        </div>
      ))}
    </dl>
  );
}
